import {
  isNonNullable
} from "./chunk-K54LRIUM.mjs";

// lib/components/form/number-format-input/number-format-input.tsx
import classNames from "classnames";
import { NumericFormat } from "react-number-format";
import { jsx } from "@emotion/react/jsx-runtime";
var NumberFormatInput = ({ onChange, ...props }) => {
  return /* @__PURE__ */ jsx(
    NumericFormat,
    {
      ...props,
      className: classNames("input", props.className),
      style: {
        textAlign: "right",
        ...props.style
      },
      thousandSeparator: true,
      displayType: "input",
      onValueChange: (e, source) => {
        source.source !== "prop" && onChange?.(e.floatValue);
      },
      onKeyDown: (e) => {
        const step = Number(props.step ?? 1);
        switch (e.key) {
          case "ArrowUp": {
            e.preventDefault();
            onChange?.((props.value ?? 0) + (step ?? 1));
            break;
          }
          case "ArrowDown": {
            const min = isNonNullable(props.min) ? Number(props.min) : void 0;
            const next = (props.value ?? 0) - (step || 1);
            const allow = min ? min <= next : props.allowNegative ? true : 0 <= next;
            onChange?.(allow ? next : props.value);
            e.preventDefault();
            break;
          }
        }
        props.onKeyDown?.(e);
      }
    }
  );
};

export {
  NumberFormatInput
};
